import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An1(props) {
    const { nodes } = useGLTF('3ds/an/An1.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An1) {
                        global.gw.geometries.An1 = e.geometry;
                    }
                }}
                name="An1"
                geometry={nodes.An1.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An1.gltf');
